import { en } from './en'
import { ru } from './ru'
import { it } from './it'
import { zh } from './zh'
import { pt } from './pt'
import { ko } from './ko'
import { de } from './de'
import { pl } from './pl'
import { fr } from './fr'
import { yue } from './yue'

export const translations = {
  en,
  zh,
  ru,
  it,
  pt,
  ko,
  de,
  pl,
  fr,
  yue,
} as const

export type Language = keyof typeof translations
export type TranslationKey = typeof en

// Helper function to get nested translation
export function getTranslation(lang: Language, key: string): string {
  const keys = key.split('.')
  let value: any = translations[lang]

  for (const k of keys) {
    value = value?.[k]
  }

  return typeof value === 'string' ? value : key
}

// Default language
export const defaultLanguage: Language = 'en'

// Supported languages
export const supportedLanguages: Language[] = ['en', 'ru', 'zh', 'it', 'pt', 'ko', 'de', 'pl', 'fr', 'yue']

// Language names for display
export const languageNames = {
  en: 'English',
  ru: 'Русский',
  zh: '中文',
  it: 'Italiano',
  pt: 'Português',
  ko: '한국어',
  de: 'Deutsch',
  pl: 'Polski',
  fr: 'Français',
  yue: '粵語（香港）',
} as const